/* globals $ */
import { registerClass } from 'libs/ComponentLoader'

import './styles.scss'

class QuantityStepper {
  constructor (element) {
    this.$el = $(element)
    this.id = this.$el.attr('id')
    this.maxNumber = parseInt(this.$el.data('maxqty'), 10)
    this.minNumber = 1
    this.$qtyAmount = this.$el.find('.quantityStepper-stepper')
    this.$plusButton = this.$el.find('.quantityStepper-quantityButton--plus')
    this.$messages = $(`.quantityStepper-message[data-message-for=${this.id}]`)

    this.quantityStepper = this.quantityStepper.bind(this)
    this.quantityChanged = this.quantityChanged.bind(this)
    this.disableQtyControls = this.disableQtyControls.bind(this)
    this.enableQtyControls = this.enableQtyControls.bind(this)

    this.$el.on('click', '.quantityStepper-quantityButton', this.quantityStepper)

    this.$qtyAmount.on('change', this.quantityChanged)
  }

  // Qty Stepper
  quantityStepper (e) {
    e.preventDefault()
    const currentNumber = parseInt(this.$qtyAmount.val(), 10)
    const { maxNumber, minNumber } = this

    // add or minus selected
    const qtyDirection = $(e.currentTarget).data('adjustqty')
    let updatedQty

    // updated based on above condtions
    if (qtyDirection === 'plus' & currentNumber <= maxNumber) {
      updatedQty = currentNumber + 1
    } else if (qtyDirection === 'plus' & currentNumber >= maxNumber) {
      updatedQty = maxNumber
    } else if (qtyDirection === 'minus' & currentNumber > minNumber) {
      updatedQty = currentNumber - 1
    } else {
      updatedQty = 1
    }

    if (updatedQty !== currentNumber) {
      this.$qtyAmount.val(updatedQty)
      this.$qtyAmount.trigger('change')
    }
  }

  quantityChanged () {
    const enteredValue = parseInt(this.$qtyAmount.val())
    const {
      maxNumber,
      minNumber
    } = this

    this.enableQtyControls()

    if (isNaN(enteredValue)) {
      this.$qtyAmount.val(minNumber)
    } else if (enteredValue >= maxNumber) {
      this.$qtyAmount.val(maxNumber)
      this.disableQtyControls()
    } else if (enteredValue < minNumber) {
      this.$qtyAmount.val(minNumber)
    }
  }

  adjustMaxQuantity (adjustQuantity) {
    this.maxNumber -= adjustQuantity

    if (this.maxNumber <= 0) {
      this.maxNumber = 0
      this.$el.addClass('quantityStepper--disabled')
      this.$qtyAmount.prop('disabled', true)
      this.$el.find('.quantityStepper-quantityButton').prop('disabled', true)
      this.$qtyAmount.val(0)
      this.disableQtyControls()
    } else {
      this.$qtyAmount.val(1)
    }
  }

  disableQtyControls () {
    this.$plusButton.prop('disabled', true)
    this.$messages.removeClass('u--hide')
  }

  enableQtyControls () {
    this.$plusButton.prop('disabled', false)
    this.$messages.addClass('u--hide')
  }
}

registerClass('QuantityStepper', QuantityStepper)
